import { Fragment, useState } from "react";

import tools from "tools/functions";
import mainStore from "store/mainStore";
import TagSelector from "./TagSelector";

function RestCardProduct({
  product,
  updateMsg,
  handleModal,
  closeModal,
  optional,
  shopId,
}) {
  const { store, record, updateRecord, updateStore } = mainStore();
  const [pendingLine, setPendingLine] = useState(null);
  const [showTagSelector, setShowTagSelector] = useState(false);

  function addLineToStores(line) {
    const linesRecord = record.lines;
    let linesStore = store.lines;

    linesRecord.set(line.id, line);
    updateRecord(record);

    const _line = { ...line };
    _line.product = _line.product.id;
    delete _line.total_amount;
    delete _line.amount_w_tax;

    if (!linesStore) {
      linesStore = new Map();
      linesStore.set("create", new Map());
    }
    const to_create = linesStore.get("create");
    to_create.set(line.id, _line);
    store.lines = linesStore;

    updateStore(store);
  }

  function handleOptionsAfter() {
    if (product["products_mix."]?.length > 0) {
      handleModal(product["products_mix."]);
    } else {
      closeModal?.();
    }
  }

  function onSelect(e) {
    e.preventDefault();
    let product_ = product;
    let uom = product.sale_uom;
    let unit_price = product.sale_price;
    let sale_price_taxed = product.sale_price_taxed;
    let quantity = 1;
    if (optional) {
      const p_option = product["option."];
      product_ = {
        id: p_option.id,
        name: p_option.name,
        sale_price_taxed: p_option.list_price,
      };
      uom = product.unit;
      unit_price = product.list_price;
      sale_price_taxed = product.sale_price_taxed;
      quantity = product.quantity || 1;
    }

    const timeStamp = new Date();
    const rec_id = -timeStamp.getTime();
    const line = {
      id: rec_id,
      product: product_,
      quantity: quantity,
      status_order: "draft",
      unit: uom,
      base_price: unit_price.toString(),
      unit_price: unit_price.toString(),
      amount_w_tax: sale_price_taxed,
      unit_price_w_tax: sale_price_taxed,
      shop_id: shopId,
    };

    if (product?.["tags."] && product["tags."].length > 0) {
      line.product.tags = product["tags."];
    }

    updateMsg(product.name);

    const hasOptions = product["products_mix."]?.length > 0;
    const hasTags = product?.["tags."]?.length > 0;

    if (optional) {
      addLineToStores(line);
      const subOptions = product["products_mix."];
      if (subOptions && subOptions.length > 0) {
        handleModal(subOptions);
      } else {
        closeModal?.();
      }
    } else if (hasTags) {
      setPendingLine(line);
      setShowTagSelector(true);
    } else if (hasOptions) {
      addLineToStores(line);
      handleModal(product["products_mix."]);
    } else {
      addLineToStores(line);
    }
  }

  return (
    <div
      className={
        "overflow-hidden mx-2 my-2 cursor-pointer rounded-lg border-[1px] border-gray-200 active:scale-95 active:bg-lime-100 transition-all duration-200 ease-out"
      }
      onClick={onSelect}
    >
      <Fragment>
        <div className="py-1 px-3 h-12 bg-stone-700">
          <p className="text-xs md:text-sm text-left text-stone-200 mx-auto my-auto font-medium line-clamp-2">
            {optional ? product["option."].name : product.name}
          </p>
        </div>
        <div className="flex bg-stone-600 h-8 lg:h-12">
          <div className="bg-amber-300 w-3 h-3 my-auto ml-4 rounded-full" />
          <p className="text-xs md:text-base text-right ml-auto mr-3 py-[4px] text-stone-200 mx-auto my-auto">
            ${tools.fmtMoney(product.sale_price_taxed)} - {product.quantity}
          </p>
        </div>
      </Fragment>

      {showTagSelector && (
        <TagSelector
          open={showTagSelector}
          onClose={() => {
            setShowTagSelector(false);
            setPendingLine(null);
          }}
          onConfirm={(selectedTagsNames) => {
            const line = { ...pendingLine, note: selectedTagsNames };
            addLineToStores(line);
            setShowTagSelector(false);
            setPendingLine(null);
            handleOptionsAfter();
          }}
          onSkip={() => {
            addLineToStores(pendingLine);
            setShowTagSelector(false);
            setPendingLine(null);
            handleOptionsAfter();
          }}
          tags={product?.["tags."] || []}
        />
      )}
    </div>
  );
}

export default RestCardProduct;
